import styled from 'styled-components';

export const StyledSkeletonSVG = styled.svg`
  rect,
  circle {
    fill: url(#skeleton-svg-gradient);
  }
`;

